import React, { useState } from 'react';
import Work1 from "../../assets/Ecomerece.jpg";
import Work2 from "../../assets/CV Builder.jpg";
import Work3 from "../../assets/netflix.jpg";
import Work4 from "../../assets/littel lemon website.jpg";
import Work5 from "../../assets/jujutsu kaisen sukuna Animated Landing Page (02.04.2024 16_12).jpg";
import Work6 from "../../assets/Spotify - Web Player_ Music for everyone (02.04.2024 16_27).jpg";

const Project = ({ project }) => {
    return (
        <div className="work_card">
            <h3 className='work_title'>{project.title}</h3>
            <img src={project.image} alt="" className='work_img' />

            <a href={project.demoLink} className='work_button'>
                Demo <i className="bx bx-right-arrow-alt work_button-icon"></i>
            </a>
            <a href={project.githubLink} className='work_button' target='blank'>
                <i className='uil uil-github-alt work_button-icon'></i>GitHub
            </a>
        </div>
    );
};

const Portfolio = () => {
    // Sample project data
    const projects = [
        {
            id: 1,
            image: Work1,
            title: 'E-Commerce Web App',
            category: 'apps',
            demoLink: 'https://heaven-born-contact.000webhostapp.com/',
            githubLink: 'https://github.com/Vrushal143',
        },
        {
            id: 2,
            image: Work2,
            title: 'Online Resume Builder',
            category: 'apps',
            demoLink: 'https://online-cv-bulid.netlify.app/',
            githubLink: 'https://github.com/Vrushal143',
        },
        {
            id: 3,
            image: Work3,
            title: 'Netflix Clone',
            category: 'website',
            demoLink: 'https://nflix-clone01.netlify.app/',
            githubLink: 'https://github.com/Vrushal143',
        },
        {
            id: 4,
            image: Work4,
            title: 'Little Lemon Website',
            category: 'design',
            demoLink: '#',
            githubLink: 'https://github.com/Vrushal143',
        },
        {
            id: 5,
            image: Work5,
            title: 'Animation Landing Page',
            category: 'design',
            demoLink: 'https://effulgent-lolly-560439.netlify.app/',
            githubLink: 'https://github.com/Vrushal143',
        },
        {
            id: 6,
            image: Work6,
            title: 'Spotify Clone',
            category: 'apps',
            demoLink: 'https://vsmusic.freewebhostmost.com/',
            githubLink: 'https://github.com/Vrushal143',
        },
    ];

    // State to manage the filtered projects
    const [filteredProjects, setFilteredProjects] = useState(projects);

    // Function to filter projects by category
    const filterProjects = (category) => {
        if (category === 'all') {
            setFilteredProjects(projects);
        } else {
            const filtered = projects.filter(project => project.category === category);
            setFilteredProjects(filtered);
        }
    };

    return (
        <div>
            <div className="work_filters">
                <button onClick={() => filterProjects('all')}>All</button>
                <button onClick={() => filterProjects('apps')}>Apps</button>
                <button onClick={() => filterProjects('website')}>Web </button>
                <button onClick={() => filterProjects('design')}>Designs </button>
            </div>
            <div className="work_container container grid">
                {/* Iterate through filtered projects */}
                {filteredProjects.map(project => (
                    <Project key={project.id} project={project} />
                ))}
            </div>
        </div>
    );
};

export default Portfolio;
